import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ValidationService } from 'src/app/services/validation.service';
import { ExportParameters } from 'src/app/models/export/ExportParameters';
import { LearnerService } from 'src/app/services/learner.service';
import { Learner } from 'src/app/models/Learner';
import { HelpModalPage } from 'src/app/modals/help-modal/help-modal.page';

@Component({
  selector: 'app-export-project-distribute',
  templateUrl: './export-project-distribute.component.html',
  styleUrls: ['./export-project-distribute.component.scss'],
})
export class ExportProjectDistributeComponent implements OnInit {

  @Input() public exportParameters: ExportParameters;
  public isModalOpen: boolean = false;

  constructor(
    public unfocusService: UnfocusElementService,
    public validateService: ValidationService,
    public learnerService: LearnerService,
    public modalController: ModalController
  ) { }

  ngOnInit() {}

  getNonSelectedLearners(): Learner[]{
    return this.learnerService.learners.filter(learner => !this.exportParameters.learners.some(l => l.learnerId == learner.learnerId));
  }

  addLearner(learner: Learner){
    const learnerIndex = this.exportParameters.learners.findIndex(l => l.learnerId == learner.learnerId);
    if(learnerIndex === -1){
      this.exportParameters.learners.push(learner);
    }
  }

  removeLearner(learner: Learner){
    const learnerIndex = this.exportParameters.learners.findIndex(l => l.learnerId == learner.learnerId);
    if(learnerIndex >= 0){
      this.exportParameters.learners.splice(learnerIndex, 1);
    }
  }

  setIsEmailEditorOpen(value: boolean){
    this.exportParameters.isEmailEditorOpen = value;
    this.exportParameters.emailTextEdit = this.exportParameters.emailText;
  }

  async emailEditorHelp(event){
    this.unfocusService.unfocus(event);

    if(this.isModalOpen === true) return;
    this.isModalOpen = true;

    const modal = await this.modalController.create({
      component: HelpModalPage,
      id: 'help-modal-ExportInvitations',
      componentProps: {
        "helpToDisplay": "E-mail Editor"
      }
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
    });

    return await modal.present();
  }

}
